module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/toc01#chap_10",
      "id": "chap10"
    }
  }, [_vm._v("WHY DO WE HAVE MUSIC?")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterAuthor"
  }, [_vm._v("Jarvis Cocker")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("musician and broadcaster")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("That’s a very good question. I wish I knew the answer (just joking!) Yes, it’s true that if music disappeared from the world no one would die. It’s not like air or water – we can live without it – but just think how boring life would be if it did disappear. Discos would go out of business, concerts would just be one big crowd of people staring at another, much smaller, crowd of people standing on a stage. In silence. As for Musical Statues … well, it would never get going would it?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But seriously, every society on Earth has music so there must be some point to it. In fact, some scientists think that humans were singing & making music long before they learned how to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Perhaps it was our very first form of communication. & it can still be a way of communicating without words today: think about ‘happy’ songs & ‘sad’ songs. They both use the same musical notes (there are only twelve, you know) & yet are so different in mood. ‘Ah, that’s because of the words,’ you might say. But no. Try listening to the radio in a country where you don’t speak the language. You’ll still be able to tell the happy songs from the sad ones. It’s the SOUND of the music that tells you. How does it work? I don’t know – but it does. It’s kind of magic & I think that’s why we have it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It’s magic & we can have it whenever we want it. When you put one of your favourite songs on & get a sort of shivery feeling behind your ears & down the back of your neck (even goosebumps sometimes) that’s one of the best feelings there is.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I like films & books & plays & paintings but they don’t give me that same magical feeling. Only music does that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("& that’s why we have it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711e6788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap10.vue
// module id = 99
// module chunks = 0